import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Login from './Login/Login';
import Form from './Form/Form';
import Signup from './Signup';
import VerifyEmail from './VerifyEmail';
import ForgotPassword from './ForgotPassword';
import ResetPassword from './ResetPassword';
import Navigationbar from './Navigationbar/Navigationbar';
import AdminNavigationbar from './Navigationbar/AdminNavigationbar';
import AdminBreadcrumb from './Navigationbar/AdminBreadcrumb';
import CustomBreadCrumbs from './Navigationbar/CustomBreadCrumbs';
import ApplicationDraft from './ApplicationDraft/ApplicationDraft';
import ApplicationStatusPage from './ApplicationStatus/ApplicationStatusPage';
import SubmitDocuments from './SubmitDocuments/SubmitDocuments';
import GetRefereeResponse from './GetRefereeResponse';
import { Dashboard, ManageUsers, ScoringCriteria } from './AdminDashboard';
import ViewApplication from './AdminDashboard/ViewApplication';
import AdminLogin from './Login/AdminLogin';
import ComingSoon from './ComingSoon/ComingSoon';
import ReviewerDashboard from './ReviewerDashboard/ReviewerDashboard';
import ReviewApplication from './ReviewerDashboard/ReviewApplication';
import ProtectedRoute from './components/ProtectedRoute';
import AdminResetPassword from './ResetPassword/adminResetPassword';
const AppRouter = () => {
	const token = sessionStorage.getItem('token');
	const applicationId = sessionStorage.getItem('applicationId');
	const hasTokenAndAppId = !!token && !!applicationId;
	const path = window.location.pathname || '';
	const isAdminPath = (path.includes('admin') || path.includes('reviewer'));

	// Registration start date: December 01, 2025
	const registrationStartDate = new Date('2026-01-01T00:00:00');
	const currentDate = new Date();
	//if localhost then always true
	const isLocalhost = window.location.hostname === 'localhost';
	const isRegistrationOpen = isLocalhost || currentDate >= registrationStartDate;

	//const isRegistrationOpen = currentDate >= registrationStartDate;
	console.log(isAdminPath, path);
	return (
		<>
			{isAdminPath ? <AdminNavigationbar /> : <Navigationbar />}
			{isAdminPath ? null : <CustomBreadCrumbs />}
			<ToastContainer 
				position="top-right" 
				autoClose={3000}
				hideProgressBar={false}
				newestOnTop={false}
				closeOnClick
				rtl={false}
				pauseOnFocusLoss
				draggable
				pauseOnHover
			/>
			<Routes>
				{/* Admin routes - always accessible */}
				<Route
					exact
					path="/admin/login"
					element={hasTokenAndAppId ? <Navigate to="/admin/dashboard" replace /> : <AdminLogin />}
				/>
				<Route path="/admin/reset-password" element={<AdminResetPassword />} />
				{/* Admin routes - accessible by admin, editor, viewer (NOT reviewer) */}
				<Route
					path="/admin/dashboard"
					element={
						<ProtectedRoute allowedRoles={['admin', 'editor', 'viewer']}>
							<Dashboard />
						</ProtectedRoute>
					}
				/>
				<Route
					path="/admin/manage-users"
					element={
						<ProtectedRoute allowedRoles={['admin', 'editor', 'viewer']}>
							<ManageUsers />
						</ProtectedRoute>
					}
				/>
				<Route
					path="/admin/scoring-criteria"
					element={
						<ProtectedRoute allowedRoles={['admin', 'editor', 'viewer']}>
							<ScoringCriteria />
						</ProtectedRoute>
					}
				/>
				<Route
					path="/admin/applications/:id"
					element={
						<ProtectedRoute allowedRoles={['admin', 'editor', 'viewer']}>
							<ViewApplication />
						</ProtectedRoute>
					}
				/>

				{/* Reviewer routes - accessible by reviewer and admin only */}
				<Route
					path="/reviewer/dashboard"
					element={
						<ProtectedRoute allowedRoles={['reviewer', 'admin']}>
							<ReviewerDashboard />
						</ProtectedRoute>
					}
				/>
				<Route
					path="/reviewer/review/:id"
					element={
						<ProtectedRoute allowedRoles={['reviewer', 'admin']}>
							<ReviewApplication />
						</ProtectedRoute>
					}
				/>

				{/* If registration is not open, show coming soon page for non-admin routes */}
				{!isRegistrationOpen ? (
					<Route path="*" element={<ComingSoon />} />
				) : (
					<>
						<Route exact path="/" element={hasTokenAndAppId ? <Navigate to="/form" replace /> : <Signup />} />
						<Route exact path="/login" element={hasTokenAndAppId ? <Navigate to="/form" replace /> : <Login />} />
						<Route path="/form" element={hasTokenAndAppId ? <Form /> : <Navigate to="/login" replace />} />
						<Route path="/verify-email" element={<VerifyEmail />} />
						<Route path="/referee-response" element={<GetRefereeResponse />} />
					<Route path="/forgotpassword" element={<ForgotPassword />} />
					<Route path="/reset-password" element={<ResetPassword />} />
					<Route path="/applicationdraft" element={<ApplicationDraft />} />
					<Route path="/applicationstatus" element={<ApplicationStatusPage />} />
					<Route path="/submitdocuments" element={<SubmitDocuments />} />
					</>
				)}
			</Routes>
		</>
	);
};

export default AppRouter;
